import './isins.scss'

import { Button, Checkbox, Table } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import classnames from 'classnames'
import React, { useState } from 'react'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetcher } from '../../../api'
import { momentDateHandler } from '../../../date/moment-date-handler'
import { CreateIsinDrawer } from '../CreateIsin'
import { Isin } from '../models'
import { UpdateIsinDrawer } from '../UpdateIsin'
import { UpdateIsinRatingDrawer } from '../UpdateIsinRating'
import { UploadIsinPrices } from '../UploadIsinPrices/UploadIsinPrices'
import { buildIsinsTableColumns } from './isins-table-columns'

const { isAfter, newDate, now } = momentDateHandler

const byMaturedIsins = (isins: Isin[]) =>
  isins.filter((isin) => isAfter({ firstDate: newDate(isin.maturity), secondDate: now() }))

export const Isins = () => {
  const [updateIsinRatingId, setUpdateIsinRatingId] = useState(null)
  const [updateIsin, setUpdateIsin] = useState(null)
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false)
  const [showMaturedIsin, setShowMaturedIsins] = useState(false)

  const { data: isins, mutate } = useSWR<Isin[]>('/isins', fetcher, { suspense: true })

  const columns = buildIsinsTableColumns({ onUpdateIsinRatings: setUpdateIsinRatingId, onUpdateIsin: setUpdateIsin })

  const onCloseDialogs = () => {
    setUpdateIsinRatingId(null)
    setIsCreateDrawerOpen(false)
    setUpdateIsin(null)
  }

  const onSuccess = () => {
    onCloseDialogs()
    mutate()
  }

  return (
    <Column className="isins">
      <Row className="actions" justifyContentEnd alignItemsCenter>
        <Checkbox
          checked={showMaturedIsin}
          onChange={(event: CheckboxChangeEvent) => setShowMaturedIsins(event.target.checked)}
        >
          Show matured ISINs
        </Checkbox>
        <UploadIsinPrices />
        <Button type="primary" onClick={() => setIsCreateDrawerOpen(true)}>
          Create ISIN
        </Button>
      </Row>

      <Table
        rowClassName={(isin: Isin) => classnames({ active: isin.isin === updateIsinRatingId })}
        columns={columns}
        loading={!isins}
        dataSource={showMaturedIsin ? isins : byMaturedIsins(isins)}
        pagination={{ pageSize: 50 }}
        rowKey="id"
        size="small"
      />

      <CreateIsinDrawer isVisible={isCreateDrawerOpen} onClose={onCloseDialogs} onSuccess={onSuccess} />
      <UpdateIsinDrawer isin={updateIsin} isVisible={!!updateIsin} onClose={onCloseDialogs} onSuccess={onSuccess} />
      <UpdateIsinRatingDrawer isin={updateIsinRatingId} isVisible={!!updateIsinRatingId} onClose={onCloseDialogs} />
    </Column>
  )
}
